/* ----------------------------------------------------------
   ADD-ON PRODUCT: ADD TO CART + LIVE CART DRAWER UPDATE
----------------------------------------------------------- */

const ADDON_BUTTON_SELECTOR = "[data-addon-add-button]";
const ADDON_BLOCK_SELECTOR = ".cart__addon-product";
const CART_ITEMS_HOLDER_SELECTOR = "[data-items-holder]";
const CART_FORM_SELECTOR = "[data-cart-form]";

let cartItemsRequest = null;

document.addEventListener("click", function (e) {
  const btn = e.target.closest(ADDON_BUTTON_SELECTOR);
  if (!btn) return;

  e.preventDefault();
  const state = btn.dataset.addonState || "add";

  if (state === "remove") {
    removeAddonVariant(btn);
  } else {
    addAddonVariant(btn);
  }
});

document.addEventListener("theme:product:add", function (event) {
  const button = event.detail?.button;
  if (!button || !button.matches(ADDON_BUTTON_SELECTOR)) return;

  setAddonButtonState(button, "remove");
  const block = button.closest(ADDON_BLOCK_SELECTOR);
  collapseAddonBlock(block);
  if (block) {
    block.dataset.addonHasItem = "true";
    toggleAddonBlockVisibility(block, false);
  }
});

document.addEventListener("theme:cart:change", syncAddonState);
document.addEventListener("theme:cart-drawer:close", handleCartDrawerClose);
document.addEventListener("DOMContentLoaded", initAddonBlocks);
document.addEventListener("shopify:section:load", initAddonBlocks);

function initAddonBlocks() {
  document.querySelectorAll(ADDON_BUTTON_SELECTOR).forEach((button) => {
    if (!button.dataset.addText) {
      button.dataset.addText = (button.textContent || "").trim();
    }
  });

  syncAddonState();
}

async function syncAddonState() {
  const addonBlocks = document.querySelectorAll(ADDON_BLOCK_SELECTOR);
  if (!addonBlocks.length) {
    updateCartFormShadow();
    return;
  }

  try {
    const cartItems = await getCartItems();
    addonBlocks.forEach((block) => {
      const variantId = block.dataset.addonVariantId;
      const button = block.querySelector(ADDON_BUTTON_SELECTOR);

      if (!variantId || !button) return;

      const hasAddon = cartItems.some((item) => String(item.variant_id) === variantId);
      block.dataset.addonHasItem = hasAddon ? "true" : "false";
      setAddonButtonState(button, hasAddon ? "remove" : "add");

      if (hasAddon) {
        collapseAddonBlock(block);
      }

      // Hide the gift box dropdown when addon is in cart
      const shouldShowBlock = !hasAddon;
      toggleAddonBlockVisibility(block, shouldShowBlock);
    });

    updateCartFormShadow();
  } catch (error) {
    console.error("Add-on Visibility Error:", error);
  }
}

function addAddonVariant(button) {
  const form = button.closest("[data-addon-form]");
  if (!form) return;

  // Ensure the note property input exists in the form
  const propertyInput = form.querySelector('input[name="properties[Note]"]');
  if (!propertyInput) {
    const propertyInputEl = document.createElement("input");
    propertyInputEl.type = "hidden";
    propertyInputEl.name = "properties[Note]";
    propertyInputEl.value = "Any large items will be packaged separately.";
    form.appendChild(propertyInputEl);
  }

  document.dispatchEvent(
    new CustomEvent("theme:cart:add", {
      detail: { button },
      bubbles: false
    })
  );
}

async function removeAddonVariant(button) {
  const block = button.closest(ADDON_BLOCK_SELECTOR);
  const variantId = block?.dataset.addonVariantId;
  if (!variantId) return;

  collapseAddonBlock(block);
  toggleCartLoading(true);
  let shouldUnsetCartLoading = true;

  setAddonButtonLoading(button, true);

  try {
    const cartItems = await getCartItems();
    const lineItem = cartItems.find((item) => String(item.variant_id) === variantId);
    const lineIndex = lineItem?.lineIndex;

    if (!lineIndex) {
      throw new Error("Add-on line item not found");
    }

    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ line: lineIndex, quantity: 0 })
    });

    if (!response.ok) throw new Error("Remove failed");

    document.dispatchEvent(
      new CustomEvent("theme:cart:refresh", {
        bubbles: true
      })
    );
    setAddonButtonState(button, "add");
    if (block?.dataset) {
      block.dataset.addonHasItem = "false";
      delete block.dataset.addonShowUntilClose;
    }
    toggleAddonBlockVisibility(block, true);
    shouldUnsetCartLoading = false;
  } catch (error) {
    console.error("Add-on Remove Error:", error);
  } finally {
    setAddonButtonLoading(button, false);
    if (shouldUnsetCartLoading) {
      toggleCartLoading(false);
    }
  }
}

function setAddonButtonState(button, state) {
  const addText = button.dataset.addText || "Add";
  const removeText = button.dataset.removeText || "Remove";

  button.dataset.addonState = state;

  if (state === "remove") {
    button.textContent = removeText;
    button.classList.add("is-remove");
  } else {
    button.textContent = addText;
    button.classList.remove("is-remove");
  }
}

function setAddonButtonLoading(button, isLoading) {
  button.classList.toggle("loading", isLoading);
  button.disabled = isLoading;
}

function collapseAddonBlock(block) {
  if (!block) return;
  const accordion = block.querySelector("[data-addon-accordion]");
  accordion?.removeAttribute("open");
}

function handleCartDrawerClose() {
  document.querySelectorAll(ADDON_BLOCK_SELECTOR).forEach((block) => {
    collapseAddonBlock(block);

    const hasAddon = block.dataset.addonHasItem === "true";
    // Hide the gift box dropdown when addon is in cart
    toggleAddonBlockVisibility(block, !hasAddon);
  });

  updateCartFormShadow();
}

function toggleAddonBlockVisibility(block, shouldShow) {
  if (!block) return;
  if (shouldShow) {
    block.style.removeProperty("display");
  } else {
    block.style.display = "none";
  }

  updateCartFormShadow();
}

function updateCartFormShadow() {
  const cartForm = document.querySelector(CART_FORM_SELECTOR);
  if (!cartForm) return;

  const visibleAddonExists = Array.from(document.querySelectorAll(ADDON_BLOCK_SELECTOR)).some(
    (addon) => window.getComputedStyle(addon).display !== "none"
  );

  if (visibleAddonExists) {
    cartForm.style.removeProperty("box-shadow");
  } else {
    cartForm.style.boxShadow = "0 -4px 8px 3px #00000012";
  }
}

function getCartItems() {
  if (!cartItemsRequest) {
    cartItemsRequest = fetch("/cart.js", {
      headers: { "Accept": "application/json" }
    })
      .then((res) => {
        if (!res.ok) throw new Error("Cart fetch failed");
        return res.json();
      })
      .then((cart) => {
        const items = cart.items || [];
        return items.map((item, index) => ({
          ...item,
          lineIndex: index + 1
        }));
      })
      .finally(() => {
        cartItemsRequest = null;
      });
  }

  return cartItemsRequest;
}

function toggleCartLoading(isLoading) {
  const cartRoot =
    document.querySelector("cart-drawer") ||
    document.querySelector("[data-cart-drawer]") ||
    document.querySelector("[data-cart-page]") ||
    document.querySelector(".cart");

  if (!cartRoot) return;
  cartRoot.classList.toggle("is-loading", isLoading);
}
